import { BaseEnum } from './BaseEnum';

export class IncidentInvolvedActor extends BaseEnum {
  static MEMBER = 'MEMBER';
}

export default IncidentInvolvedActor;
